import React, { useMemo } from 'react';
import { EFieldMappingModes } from '@timeedit/types/lib/enums';
import FreeMappingFieldMapping from './FreeMappingFieldMapping';
import MappedFieldMapping from './MappedFieldMapping';
// COMPONENTS
import RawFieldMapping from './RawFieldMapping';

type FieldMappingType = {
  appName?: any;
  objectType?: any;
  objectTypeIdx?: any;
};
const FieldMapping = ({
  appName,
  objectType,
  objectTypeIdx,
}: FieldMappingType) => {
  const activeView = useMemo(() => {
    const { fieldMappingMode } = objectType;
    switch (fieldMappingMode) {
      case EFieldMappingModes.RAW:
        return <RawFieldMapping />;

      case EFieldMappingModes.MAPPED:
        return (
          <MappedFieldMapping
            appName={appName}
            objectType={objectType}
            objectTypeIdx={objectTypeIdx}
          />
        );

      case EFieldMappingModes.FREE_MAPPING:
        return (
          <FreeMappingFieldMapping
            appName={appName}
            objectType={objectType}
            objectTypeIdx={objectTypeIdx}
          />
        );

      default:
        return null;
    }
  }, [objectType]);

  return <div className="field-mapping--wrapper">{activeView}</div>;
};

export default FieldMapping;
